import React from 'react';
import ReactHighcharts from 'react-highcharts';
import md5 from 'md5';
import _ from 'lodash';

import colorHelper from '../../lib/colorLuminance';

class SaleCallChartWidget extends React.Component {
    static getInitials(user) {
        if (!user) {
            return '';
        }

        let i1 = '';
        let i2 = '';
        let nameArray = [];

        if (user) {
            i1 = user.charAt(0);
            nameArray = user.split(' ');

            if (nameArray.length > 2) {
                i2 = nameArray[nameArray.length - 1].charAt(0);
            } else if (nameArray.length === 2) {
                i2 = nameArray[1].charAt(0);
            }
        }

        return i1 + i2;
    }

    static isGreaterThanBest(value, max, color) {
        if (max === 0) {
            return color;
        } else if (value >= max) {
            return '#5cb85c';
        }

        return color;
    }

    static getBestOfList(rows, entity) {              
        const max = _.maxBy(rows, entity);
        const bestOfList = _.filter(rows, row => row[entity] === max[entity]);
    
        let list = bestOfList.map(best => best[entity]);
        return list;
    }

    labelFormatter() {
        if (this.value.type !== 'user' || this.value.displayType === 'text') {
            let name = this.value.name;
            if (name.length > 15) {
                name = `${name.substr(0, 12)}...`;
            }
            return `<span>${name}</span>`;
        }

        if (this.value.displayType === 'picture') {
            return `<div class="user-holder"><div title="${this.value.name}" class="userImage" style="background: ${this.value.bgColor}">
                <div class="initials">
                    <span>${this.value.initials}</span>
                </div>
                <img src="//gravatar.com/avatar/${this.value.hash}?size=100&d=blank&r=x" class="avatar" alt="${this.value.name}"/>
            </div></div>`;
        }

        return `<div class="user-holder"><div title="${this.value.name}" class="userImage" style="background: ${this.value.bgColor}">
            <div class="initials">
                <span>${this.value.initials}</span>
            </div>
            <img src="//gravatar.com/avatar/${this.value.hash}?size=100&d=blank&r=x" class="avatar" alt="${this.value.name}"/>
        </div>${this.value.name.split(' ')[0]}</div>`;
    }

    numberFormatter() {
        const str = this.value.toString().split('.');
        if (str[0].length >= 5) {
            if (str[0].length > 6) {
                // str[0] = str[0].substr(0, 1) + 'M';
                str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
            } else {
                str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
            }
        }
        if (str[1] && str[1].length >= 5) {
            str[1] = str[1].replace(/(\d{3})/g, '$1 ');
        }

        return str.join(' ');
    }

    dataNumberFormatter() {
        const str = Math.ceil(this.y).toString().split('.');
        if (str[0].length >= 5) {
            str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
        }
        if (str[1] && str[1].length >= 5) {
            str[1] = str[1].replace(/(\d{3})/g, '$1 ');
        }
        return str.join(' ');
    }

    render() {
        const { widget, widgetData, companyProfile, isThumbnail } = this.props;

        //set entity as which value should be plotted on y-axis
        let entity;
        if (widget.displayConfig && widget.displayConfig.labelType === 'onlyCalls') {
            entity = 'numberOfCalls';
        } else if (widget.displayConfig && widget.displayConfig.labelType === 'onlyDuration') {
            entity = 'durationInMins';
        } else if (widget.displayConfig && widget.displayConfig.labelType === 'bothCallAndDuration') {
            entity = 'bothCallAndDuration'
        } else {
            entity = 'numberOfCalls'; //if none selected than plot by numberOfCalls
        }

        if (entity === 'bothCallAndDuration') { //if bothCallAndDuration then dont plot
            return (
                <div className="loading" style={{fontSize:"20px"}}>
                Please select 'Only Calls' or 'Only Duration' for the bar chart as it can only display one variable.
                </div>
            );
        }
        
        const defaultWidgetData = widgetData.length ? widgetData : [];

        //display a loading sign if widgetData is empty or if the entity selected by user to display has no value yet        
        if (!defaultWidgetData.length || 
            (widget.displayConfig && widget.displayConfig.labelType && defaultWidgetData[0][entity] === undefined )) {
            return (
                <div className="loading">
                    Loading
                    <i className="fa fa-refresh fa-spin fa-fw" aria-hidden="true" />
                </div>
            );
        }

        const mainColor = colorHelper.colorLuminance(companyProfile.colors.mainBg, 0);
        const lighterMainColor = colorHelper.colorLuminance(companyProfile.colors.mainBg, 0);

        if (isThumbnail) {
            return (<div className="column_chart_widget" />)
        }

        let data = _.sortBy(defaultWidgetData, entity).reverse();
        //get the max value for the entity so we can highlight that row
        const best = SaleCallChartWidget.getBestOfList(data, entity);

        const yMax = data.map((o) => {
            if (o[entity] >= best[0]) {
                return {
                    y: o[entity],
                    low: -10000,
                    color: ReactHighcharts.Highcharts.Color(mainColor).setOpacity(0.2).get('rgba'),
                };
            }

            return {
                y: o[entity],
                low: -10000,
                color: ReactHighcharts.Highcharts.Color(mainColor).setOpacity(0.2).get('rgba'),
            };
        });

        const yData = data.map((o) => {
            if (o[entity] >= 1) {
                return {
                    y: o[entity],
                    low: -10000,
                    color: SaleCallChartWidget.isGreaterThanBest(o[entity], best[0], mainColor),
                };
            }

            return {
                y: 0,
            };
        });


        const displayType = _.get(widget, 'displayConfig.labelType', 'pictureAndText');

        const xCategories = data.map(o => ({
            name: o.name,
            hash: md5(o.email),
            initials: SaleCallChartWidget.getInitials(o.name),
            type: widget.dataConfig.dividedBy,
            bgColor: mainColor,
            displayType,
        }));

        const options = {
            chart: {
                type: 'column',
                width: null,
                height: this.props.rowHeight ? this.props.rowHeight * widget.height : null,
                marginTop: 108,
                marginBottom: -40,
                spacingBottom: 10,
                spacingLeft: 40,
                marginRight: 60,
            },
            tooltip: { enabled: false },
            credits: {
                enabled: false,
            },
            title: {
                text: '',
            },
            xAxis: {
                lineWidth: 0,
                minorGridLineWidth: 0,
                type: 'category',
                minorTickLength: 0,
                tickLength: 0,
                categories: xCategories,
                labels: {
                    useHTML: true,
                    x: 0,
                    formatter: this.labelFormatter,
                    reserveSpace: true,
                    style: { height: '50px' },
                    autoRotation: 0,
                },
            },
            yAxis: {
                allowDecimals: false,
                min: 0,
                max: _.sumBy(yData, 'y') === 0 && _.sumBy(yMax, 'y') === 0 ? 5 : null,
                gridLineDashStyle: 'solid',
                gridLineColor: lighterMainColor,
                title: {
                    text: null,
                },
                labels: {
                    formatter: this.numberFormatter,
                    style: {
                        color: mainColor,
                        fontWeight: 300,
                        fontSize: 14,
                    },
                    y: 5,
                },
            },
            plotOptions: {
                column: {
                    pointWidth: 50,
                    grouping: false,
                    shadow: false,
                    dataLabels: {
                        enabled: true,
                        formatter: this.dataNumberFormatter,
                        style: {
                            color: 'contrast',
                            textShadow: '0 0 3px contrast',
                            fontWeight: '400',
                        },
                    },
                },
            },
            legend: {
                enabled: false,
            },
            series: [
                {
                    name: '',
                    index: 0,
                    data: yMax,
                    borderRadius: 5,
                    pointPadding: 0,
                },
                {
                    name: yData,
                    index: 1,
                    data: yData,
                    borderRadius: 5,
                    pointPadding: 0,
                },
            ],
        };

        return (
            <div className="column_chart_widget">
                <ReactHighcharts
                    config={options}
                    isPureConfig
                />
            </div>
        );
    }
}

SaleCallChartWidget.propTypes = {
    widget: React.PropTypes.object,
    widgetData: React.PropTypes.array,
    companyProfile: React.PropTypes.object,
    rowHeight: React.PropTypes.number,
};

export default SaleCallChartWidget;



/** WEBPACK FOOTER **
 ** ./client/components/Widgets/SaleCallChartWidget.jsx
 **/